import { type CreditCardAccount } from '@webapp/modules/accounts-payable/entities/CreditCardAccount'
import { useStartReconciliationSessionFormPresenter } from './useStartReconciliationSessionFormPresenter'
import { ReconcileAccountForm } from '../../views/ReconcileAccountForm'

export interface IStartReconciliationSessionFormPresenterProps {
  /** Session reuse + last statement date display */
  account: CreditCardAccount
  /** Match-screen variant (BHV-029, consumed in cluster 2.3) */
  importOnly?: boolean
  /** FS navigates (details → match route) or closes + refetches (match view) */
  onSuccess: () => void
  onCancel: () => void
}

// Form content only — the Reconcile ModalDialog wrapper is FS-owned.
export const StartReconciliationSessionFormPresenter = ({
  account,
  importOnly = false,
  onSuccess,
  onCancel,
}: IStartReconciliationSessionFormPresenterProps) => {
  const {
    states: { isStarting },
    methods: { onSubmit },
  } = useStartReconciliationSessionFormPresenter({ account, onSuccess })

  return (
    <ReconcileAccountForm
      account={account}
      importOnly={importOnly}
      isSaving={isStarting}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  )
}

StartReconciliationSessionFormPresenter.displayName =
  'StartReconciliationSessionFormPresenter'
